import mediaAPI from '../../services/api/media';
import Vue from 'vue'

const module = {
  namespaced: true,
  state: {
    themes: [],
    historiesProjectComments: [],
  },

  getters: {
    historiesProjectComments: state => _.filter(state.historiesProjectComments, ['visible', true]),
    historiesProjectCommentsSelected: state => _.filter(state.historiesProjectComments, ['selected', true])
  },

  actions: {
    async importFile({ commit }, formData) {
      try {
        const response = await mediaAPI.importFile(formData);

        return response;
      } catch (error) {
        console.log(error);
      }
    },

    async importTemplate({ commit }, id) {
        const response = await mediaAPI.importTemplate(id);

        return response;
    },

    createVideo({ commit }, payload) {
      return mediaAPI.createVideo(payload)
    },

    downloadVtt({ commit }, payload) {
      return mediaAPI.downloadVtt(payload)
    },

    async exportTemplate({ commit }, { rows, outputFile }) {
      const filename = outputFile ? outputFile : "New Template";

        const response = await mediaAPI.exportTemplate(rows);

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${filename}.xlsx`);
        document.body.appendChild(link);
        link.click();
    },

    async exportAssets({ commit }, { rows, outputFile }) {
      const filename = outputFile ? outputFile : "New Assets";

      try {
        const response = await mediaAPI.exportAssets(rows);

        const link = document.createElement("a");
        link.setAttribute("download", `${filename}.zip`);
        link.href = response.data.asset_path;
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (err) {
        console.log(err);
        throw err;
      }
    },

    async saveTemplate({ commit }, { rows, outputFile, themeID, newFontColor, newStrokeColor }) {
      const filename = outputFile ? outputFile : "Output";

      try {
        const { data } = await mediaAPI.saveTemplate(rows, filename, themeID, newFontColor, newStrokeColor);

        toastr.success(data.message);
        return data.template
      } catch (error) {
        toastr.error(error.response.data.message);
        throw error;
      }
    },

    async uploadFile({ commit }, payload) {
        const response = await mediaAPI.uploadFile(payload);

        return response;
    },

    unzip({ commit }, payload) {
      return mediaAPI.unzip(payload);
    },

    addTiffData(data, payload) {
        return mediaAPI.addTiffData(payload);
    },
    async convertVideo({ commit }, payload) {
        const response = await mediaAPI.convertVideo(payload);
        return response;
    },

    async convertSharedVideo({ commit }, payload) {
        return await mediaAPI.convertSharedVideo(payload);
    },

    async compressVideo({ commit }, payload) {
        return await mediaAPI.compressVideo(payload);
    },

    async uploadThumb({ commit }, payload) {
        const response = await mediaAPI.uploadThumb(payload);

        return response;
    },

    // Deliberately not catching here: swallowing the rejection and resolving to undefined
    // used to make `const { data } = await this.trimVideo(...)` in VideoEditorModal.vue throw
    // "Cannot read properties of undefined (reading 'data')" on any trim failure, masking the
    // real error message the backend sent. Letting the rejection propagate lets the caller's
    // own catch block surface it properly.
    async trimVideo({ commit }, payload) {
      return await mediaAPI.trimVideo(payload);
    },

    async cropVideo({ commit }, payload) {
      try {
        return await mediaAPI.cropVideo(payload);
      } catch (err) {
        console.log(err);
      }
    },

    async getThemes({ commit }) {
        const response = await mediaAPI.getThemes();
        
        
        commit("SET_THEMES", response.data.themes);
    },

    async saveCroppedImage({ commit }, payload) {
        const response = await mediaAPI.saveCroppedImage(payload);

        return response;
    },

    async saveRemoveBGImage({ commit }, payload) {
        const response = await mediaAPI.saveRemoveBGImage(payload);
        return response;
    },

    async getProjectVideoComments({ commit }, payload) {
        const response = await mediaAPI.getProjectVideoComments(payload);
        return response;
    },

    async addProjectVideoComment({ commit }, payload) {
        const response = await mediaAPI.addProjectVideoComment(payload);
        return response;
    },

    async addProjectVideoApproval({ commit }, payload) {
        const response = await mediaAPI.addProjectVideoApproval(payload);
        return response;
    },

    async deleteProjectVideoComment({ commit }, payload) {
        const response = await mediaAPI.deleteProjectVideoComment(payload);
        return response;
    },

    async addHistoriesProjectComment({ commit }, payload) {
        const response = await mediaAPI.addHistoriesProjectComment(payload);
        return response;
    },

    updateHistoriesProjectComment ({ commit }, payload) {
      return mediaAPI.updateHistoriesProjectComment(payload.data, payload.id)
    },

    async getHistoriesProjectComments({ commit }, payload) {
        const { data: { comment } } = await mediaAPI.getHistoriesProjectComments(payload);
        commit('FETCH_HISTORIES_PROJECT_COMMENTS', comment)
    },

    async addHistoriesProjectApproval({ commit }, payload) {
        const response = await mediaAPI.addHistoriesProjectApproval(payload);
        return response;
    },

    async addHistoriesProjectApprovalsBulk(_, payload) {
        const response = await mediaAPI.addHistoriesProjectApprovalsBulk(payload);
        return response;
    },

    async deleteHistoriesProjectComment({ commit }, payload) {
      await mediaAPI.deleteHistoriesProjectComment({ comment_id: payload.id })
      commit('DELETE_HISTORIES_PROJECT_COMMENT', payload)
    },

    async resolveHistoriesProjectComment({ commit }, payload) {
      commit('UPDATE_HISTORIES_PROJECT_COMMENT', { ...payload, isResolving: true })
      await mediaAPI.resolveHistoriesProjectComment({ comment_id: payload.id })
      commit('UPDATE_HISTORIES_PROJECT_COMMENT', { ...payload, isResolving: false, resolved: true, editable: false })
    },

    async sendMail({ commit }, payload) {
        const response = await mediaAPI.sendMail(payload);
        return response;
    },
    
    async addVideoScreenshot({ commit }, payload) {
        const response = await mediaAPI.addVideoScreenshot(payload);
        return response;
    },
    
    async deleteScreenshot({ commit }, payload) {
        const response = await mediaAPI.deleteScreenshot(payload);
        return response;
    },

    async addNewProjectComment({ commit }, payload) {
        const response = await mediaAPI.addNewProjectComment(payload);
        return response;
    },

    async getNewProjectComments({ commit }, payload) {
        const response = await mediaAPI.getNewProjectComments(payload);
        return response;
    },

    async deleteNewProjectComment({ commit }, payload) {
        const response = await mediaAPI.deleteNewProjectComment(payload);
        return response;
    },

    async addNewProjectApproval({ commit }, payload) {
        const response = await mediaAPI.addNewProjectApproval(payload);
        return response;
    },

  },

  mutations: {
    SET_THEMES(state, themes) {
      state.themes = themes;
    },

    FETCH_HISTORIES_PROJECT_COMMENTS (state, payload) {
      state.historiesProjectComments = payload
    },

    UPDATE_HISTORIES_PROJECT_COMMENT (state, payload) {
      const index = _.findIndex(state.historiesProjectComments, ['id', payload.id])
      if (index !== -1) {
        Vue.set(state.historiesProjectComments, index, payload)
      }
    },

    DELETE_HISTORIES_PROJECT_COMMENT (state, payload) {
      const removeRecursive = (comments, idToDelete) => {
        return comments
          .filter(comment => comment.id !== idToDelete && comment.parent_id !== idToDelete)
          .map(comment => {
            if (comment.replies_recursive && comment.replies_recursive.length) {
              comment.replies_recursive = removeRecursive(comment.replies_recursive, idToDelete)
            }
            return comment
          })
      }

      state.historiesProjectComments = removeRecursive(state.historiesProjectComments, payload.id)
    },
  },
};

export default module;
